import { alpha } from '@mui/material/styles';
import { palette } from '../global/palette';
export const MuiRadio = {
    MuiRadio: {
        styleOverrides: {
            root: {
                color: palette.grey[500],
                '&.Mui-focusVisible': {
                    backgroundColor: alpha(palette.primary.light, 0.1),
                },
            },
            colorPrimary: {
                '&$checked': {
                    color: palette.primary.light,
                    '&:hover': {
                        backgroundColor: alpha(palette.grey[500], 0.1),
                    },
                },
                '&:hover': {
                    backgroundColor: alpha(palette.grey[500], 0.1),
                },
                '&:active': {
                    backgroundColor: alpha(palette.primary.light, 0.1),
                },
            },
        },
    },
};
